<script>
export default {
  name: "stacked-offer",

  props: {
    offer: {
      type: Object,
      default: () => {}
    },

    value: null
  },

  watch: {
    value() {
      this.internalValue = this.value;
    },

    internalValue() {
      if (!this.readonly) this.$emit("input", this.internalValue);
    }
  },

  computed: {
    image() {
      if (this.mobileCheck()) {
        if (this.offer.mobile_images.length > 0)
          return this.offer.mobile_images[0].display_url;
      } else {
        if (this.offer.desktop_images.length > 0)
          return this.offer.desktop_images[0].display_url;
      }
    },

    activated() {
      const modifier = this.$moment().isoWeekday() * 50;
      const number = 100 + Math.random() * modifier;
      return number.toFixed(0);
    }
  },

  methods: {
    mobileCheck() {
      try {
        document.createEvent("touchEvent");
        return true;
      } catch (e) {
        return false;
      }
      return false;
    }
  },

  data() {
    return {
      internalValue: this.value
    };
  }
};
</script>

<template>
  <figure class="stacked-offer">
    <div class="image">
      <img v-if="image" :src="image" alt="Image">
    </div>
    <div class="body">
      <small class="offer-activated offer-activated-blue">
        {{ offer.name }}
        <i class="fa fa-check-circle"></i>
        <span class="text-muted">{{ activated }} signed up this week</span>
      </small>
      <h4>{{ offer.headline }}</h4>

      <div class="excerpt">{{ offer.excerpt }}</div>
      <checkbox-button :color="offer.color" v-model="internalValue">{{ offer.label_signup }}</checkbox-button>
    </div>
  </figure>
</template>

<style lang="scss">
.stacked-offer {
  display: flex;
  flex-direction: column;
  width: 480px;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.1);
  margin: 0 1.3em 1.3em;
  @media screen and (max-width: 1100px)
  {
    margin: 0 0 1.3em;
  }
  background-color: white;

  .image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 270px;
    img {
      max-height: 270px;
      width: 480px;
      @media screen and (max-width: 560px) {
        width: 300px;
      }
    }
  }

  .body {
    padding: 1.2em;
    font-family: "ProximaNova";

    h4 {
      font-weight: bold;
      margin-bottom: 0.1em;
    }

    .excerpt {
      margin-bottom: 1.2em;
      max-height: 6em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/stacked/StackedOffer.vue